const dayjs = require("dayjs")
dayjs().format()
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault("America/New_York")

let deliverr = {}

deliverr.getZipCode = async function getZipCode(storedZipCode) {

    if (storedZipCode) {
        return storedZipCode
    }
    else {
        const response = await fetch("https://location.deliverr.com/v1/zip")
        const data = await response.json()
        return data.zip
    }

}

deliverr.getZipCodeV2 = async function getZipCodeV2(myshopify_shop_name, storedZipCode, randomizationUnitId) {

    if (storedZipCode) {
        return storedZipCode
    }
    else {
        const response = await fetch(`https://shopify.deliverr.com/v1/shop/${myshopify_shop_name}/shop-badge-global-context?randomizationUnitId=${randomizationUnitId}`)
        const data = await response.json()
        return data.location.zip
    }

}

deliverr.getShippingSpeedV1 = async function (zipCode, shopifyVariantID) {

    const response = await fetch("https://shopify.deliverr.com/v1/variants/service-level/zip/" + zipCode + "?shopifyVariantIds=" + shopifyVariantID)
    const data = await response.json()
    return data

}

deliverr.getShippingSpeedV2 = async function (zipCode, shopifyVariantID) {

    const response = await fetch("https://shopify.deliverr.com/v2/variants/service-level/zip/" + zipCode + "?shopifyVariantIds=" + shopifyVariantID)
    const data = await response.json()
    return data

}

deliverr.isShippingHoliday = function (dateToCheck) {

    const holidayYear = dateToCheck.year()

    var newYearsDay = dayjs().year(holidayYear).startOf('year')
    if(newYearsDay.day() === 6) {
        newYearsDay = newYearsDay.subtract(1, 'day')
    }
    if(newYearsDay.day() === 0) {
        newYearsDay = newYearsDay.add(1, 'day')
    }

    // 1 = first; -1 = last
    const nthWeekdayInMonth = (n, weekdayIndexedToSundayZero, monthIndexedToZero) => {

        const firstDayOfMonth = dayjs().year(holidayYear).startOf('year').month(monthIndexedToZero).startOf('month')

        const daysOfMonth = Array.from(Array(firstDayOfMonth.endOf('month').date()).keys())

        const desiredWeekdaysInMonth = daysOfMonth.filter((dayOfMonth) => {

            if(firstDayOfMonth.add(dayOfMonth, 'day').day() === weekdayIndexedToSundayZero) {
                return true
            }

        })

        return dayjs().year(holidayYear).month(monthIndexedToZero).startOf('month').add(desiredWeekdaysInMonth[n === -1  ? desiredWeekdaysInMonth.length - 1 : n - 1 ], 'day')

    }
    
    //last monday in may
    const memorialDay = nthWeekdayInMonth(-1, 1, 4)
    
    const independenceDay = dayjs().year(holidayYear).month(6).date(4).startOf('day')
    
    //First Monday in September
    const labourDay = nthWeekdayInMonth(1, 1, 8)
    
    //Fourth Thursday in November
    const thanksgivingDay = nthWeekdayInMonth(4, 4, 10)

    //December 25
    var christmasDay = dayjs().year(holidayYear).startOf('year').month(11).date(25)

    if(christmasDay.day() === 6) {
        christmasDay = christmasDay.subtract(1, 'day')
    }
    if(christmasDay.day() === 0) {
        christmasDay = christmasDay.add(1, 'day')
    }

    //MLK Day - Third Monday in January
    const mlkDay = nthWeekdayInMonth(3, 1, 0)

    //Presidents' Day -Third Monday in February
    const presidentsDay = nthWeekdayInMonth(3, 1, 1)

    //Indigenous Peoples' Day - Second Monday in October
    const indigenousPeoplesDay = nthWeekdayInMonth(2, 1, 9)

    //Veterans Day - November 11
    var veteransDay = dayjs().year(holidayYear).startOf('year').month(10).date(11)
    if(veteransDay.day() === 6) {
        veteransDay = veteransDay.subtract(1, 'day')
    }
    if(veteransDay.day() === 0) {
        veteransDay = veteransDay.add(1, 'day')
    }

    var holidaysInDesiredYear = []
    holidaysInDesiredYear.push(newYearsDay.toDate())
    holidaysInDesiredYear.push(memorialDay.toDate())
    holidaysInDesiredYear.push(independenceDay.toDate())
    holidaysInDesiredYear.push(labourDay.toDate())
    holidaysInDesiredYear.push(thanksgivingDay.toDate())
    holidaysInDesiredYear.push(mlkDay.toDate())
    holidaysInDesiredYear.push(presidentsDay.toDate())
    holidaysInDesiredYear.push(indigenousPeoplesDay.toDate())
    holidaysInDesiredYear.push(veteransDay.toDate())

    return holidaysInDesiredYear.includes(dateToCheck.toDate())

}

deliverr.getNextShippingDay = function (currentDate) {

    if(deliverr.isShippingDay(currentDate.add(1, 'day'))) {

        return currentDate.add(1, 'day')

    }
    else {
        return deliverr.getNextShippingDay(currentDate.add(1, 'day'))
    }

}

deliverr.isShippingDay = function (dateToCheck) {

    const weekdays = [1,2,3,4,5]

    //check if it's a weekday
    if(weekdays.includes(dateToCheck.day())) {

        return !deliverr.isShippingHoliday(dateToCheck)

    }

    else {

        return false

    }

}

deliverr.getNextShippingDateOffset = function (currentDay) {

    var nextDay = currentDay.add(1, 'day')
    const weekdays = [1,2,3,4,5]
    console.log(currentDay)
    console.log(nextDay.day())
console.log(!weekdays.includes(nextDay.day()))
    //check if it's not a weekday
    if(!weekdays.includes(nextDay.day())) {

        return 1 + deliverr.getNextShippingDateOffset(nextDay)

    }
    else {

        //check if it's a shipping holiday
        if(deliverr.isShippingHoliday(nextDay)) {

            return 1 + deliverr.getNextShippingDateOffset(nextDay)

        }
        else {

            return 1

        }

    }
    

}

export default deliverr